export abstract class QueryPrecachingStrategyService {
  abstract hasInCache(cacheKey: string): boolean;
  abstract getFromCache<T>(cacheKey:string): T|undefined;
  abstract getFromCacheWithCallback<T>(cacheKey:string, callback:()=>Promise<T>): Promise<T>|undefined;
  initialize(): Promise<void>{ return;}
}
